/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { debounce } from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
// import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

// import authServices from 'src/redux/api/authServices'

import Stack from '@mui/material/Stack';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import {
  Box,
  Grid,
  TextField,
  Typography,
  IconButton,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from '@mui/material';
import Link from '@mui/material/Link';

// import useForm from 'src/hooks/validation';

import useForm from "../../hooks/validation.js"

// import CustomTextField from 'src/theme/textField';

// import LoadingButton from 'src/components/shared/loadingButton/LoadingButton';
import LoadingButton from "../../shared/loadingButton/LoadingButton"

import { loginStyles } from './loginStyles';
import authServices from "../../services/authServices"
import { toast } from 'react-toastify';
import { getErrorMessage } from '../../utils/index.js';

// ----------------------------------------------------------------------

const initialValues = {
  username: '',
  password: '',
};

const validationRules = {
  name: (value) => (value ? '' : 'This field is required'),

};

export default function LoginView() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { values, errors, handleOnChange, validateAllFields } = useForm(
    initialValues,
    validationRules
  );

  const handleClick = async () => {
    setIsLoading(true);
    await authServices.loginUser(values)
      .then((res) => {
        setIsLoading(false);
        console.log(res);
        localStorage.setItem('token', res?.data?.data?.token);
        navigate('/admin/announcements', { replace: true });

      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(getErrorMessage(error))
        console.log(error);
      });
  };
  const handleClickShowPassword = () => setShowPassword((w) => !showPassword);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Box >

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: "100%",
          m: 'auto',
          backgroundColor: { xs: '#fff' },
        }}
        maxWidth="1800px"
      >
        <Grid container bgcolor="#fff">
          <Grid item xs={12} md={12}>
            <Box maxWidth="sm" m="auto" sx={loginStyles.formWrapper}>
              <Box sx={loginStyles.mainWrapper}>
                <Logo />
                <Stack spacing={2.5} sx={{ width: '100%' }}>
                  <Box>
                    <InputLabel htmlFor="outlined-adornment-password">Username</InputLabel>

                    <TextField
                      fullWidth
                      type="text"
                      onChange={(e) => handleOnChange(e)}
                      name="username"
                      value={values?.username}
                      helperText={errors?.username}
                      error={errors?.username}
                      placeholder="Enter Username"

                    />
                  </Box>
                  <Box>
                    <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
                    <OutlinedInput
                      fullWidth
                      name="password"
                      value={values?.password}
                      helperText={errors?.password}
                      error={errors?.password}
                      placeholder="Enter Password"
                      type={showPassword ? 'text' : 'password'}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                      onChange={(e) => handleOnChange(e)}
                    />
                  </Box>
                  {/* <Stack onClick={() => navigate("/forgot_password")} direction="row" alignItems="center" justifyContent="flex-end" sx={{ my: 3, cursor: "pointer" }}>
                    <Link variant="subtitle2" underline="hover">
                      Forgot password?
                    </Link>
                  </Stack> */}
                </Stack>

                <LoadingButton
                  isLoading={isLoading}
                  sx={{ 
                    width: '100%',
                    backgroundColor: '#28a745',
                    '&:hover': { backgroundColor: '#218838' },
                    fontWeight: 'bold'
                  }}
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={handleClick}
                >
                  Login
                </LoadingButton>
              </Box>

            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export const Logo = () => {
  return (
    <Box sx={loginStyles.wrapper}>
      {/* <img width="40%" src={logo} alt="" /> */}
      <Typography fontWeight={400} variant='h4'>
        Sign in to your  account
      </Typography>
    </Box>
  );
};
